// Treści i konfiguracja działu „CV i kariera" (skeleton v1.0). Źródło prawdy:
// PROMPTIVO_CV_I_KARIERA_DEV_PACK_v1.0. Cennik/wartości kredytów NIE są tu wpisywane.

export const CV_GATE_MESSAGE =
  "Załóż bezpłatne konto, aby przejść do pełnego kreatora i zapisać swoje CV.";

// Lokalna nawigacja kontekstowa działu (doc 05, pkt 5).
export const CV_NAV = [
  { key: "moje", label: "Moje CV", to: "/cv/moje", requiresAuth: true },
  { key: "kreator", label: "Kreator CV", to: "/cv/kreator" },
  { key: "szablony", label: "Szablony", to: "/cv/szablony" },
  { key: "listy", label: "Listy motywacyjne", to: "/cv/listy", requiresAuth: true },
  { key: "dopasowanie", label: "Dopasowanie do oferty", to: "/cv/dopasowanie", requiresAuth: true },
  { key: "pracodawcy", label: "Pracodawcy", to: "/cv/pracodawcy", requiresAuth: true },
  { key: "aplikacje", label: "Moje aplikacje", to: "/cv/aplikacje", requiresAuth: true },
];

// CV-00 Landing
export const CV_LANDING = {
  eyebrow: "CV I KARIERA",
  title: "Profesjonalne CV i właściwi pracodawcy — krok po kroku",
  lead: "Przygotuj CV od zera albo popraw dokument, który już masz. Później możesz otrzymać bazę dopasowanych pracodawców i gotowe wiadomości aplikacyjne.",
  cta: "Zacznij tworzyć CV",
  process: [
    { title: "Rozmowa", text: "Odpowiadasz na proste pytania własnymi słowami." },
    { title: "Treść CV", text: "Porządkujemy informacje — bez dopisywania niepotwierdzonych faktów." },
    { title: "Szablon", text: "Wybierasz wygląd. Treść zostaje bez zmian." },
    { title: "Podgląd i eksport", text: "Widzisz podgląd A4, pobierasz PDF lub DOCX." },
    { title: "Pracodawcy", text: "Znajdujesz bazę dopasowanych pracodawców." },
    { title: "Wiadomości", text: "Dostajesz gotowe wiadomości aplikacyjne do wysłania." },
  ],
};

// CV-01 Dwa wejścia (dokładnie dwa)
export const CV_ENTRIES = [
  {
    key: "nowe",
    title: "Nie mam CV",
    text: "Stwórz profesjonalne CV od podstaw.",
    button: "Zacznij od początku",
    to: "/cv/kreator?tryb=nowe",
    primary: true,
  },
  {
    key: "mam",
    title: "Mam już CV",
    text: "Prześlij dokument i popraw go.",
    button: "Dodaj swoje CV",
    to: "/cv/kreator?tryb=mam",
  },
];

// Cztery uproszczone kroki (landing hero → sekcja „Jak to działa")
export const CV_STEPS = [
  { title: "Wybierz ścieżkę", text: "Zdecyduj, czy tworzysz CV od podstaw, czy chcesz poprawić istniejący dokument." },
  { title: "Uzupełnij lub prześlij CV", text: "Odpowiedz na kilka pytań lub prześlij swój plik, a my zajmiemy się resztą." },
  { title: "Wybierz szablon", text: "Dopasuj układ i styl do swojej branży. Wszystkie szablony są nowoczesne i czytelne." },
  { title: "Pobierz i aplikuj", text: "Pobierz gotowe CV i list motywacyjny w formacie PDF lub DOCX i aplikuj do dopasowanych pracodawców." },
];

export const CV_ENTRIES_NOTE =
  "Możesz zacząć bez zakładania konta. Konto będzie potrzebne przy trwałym zapisie lub pobieraniu.";

// CV-A01 Sytuacja zawodowa (steruje wywiadem)
export const CV_SITUATIONS = [
  "Szukam pierwszej pracy",
  "Szukam nowej pracy",
  "Zmieniam zawód lub branżę",
  "Wracam do pracy po przerwie",
  "Jestem uczniem lub studentem",
  "Szukam pracy za granicą",
  "Inna sytuacja",
];

// CV-B04 Cel pracy z dokumentem
export const CV_DOC_GOALS = [
  "Sprawdzić i poprawić",
  "Zmienić wygląd",
  "Dopasować do ogłoszenia",
  "Przetłumaczyć",
  "Przygotować list motywacyjny",
  "Znaleźć potencjalnych pracodawców",
];

// Galeria szablonów (kategorie + filtry) — bez komponentów HTML/CSS szablonów (niezatwierdzone).
export const CV_TEMPLATE_CATEGORIES = ["Polecane", "ATS", "Klasyczne", "Nowoczesne", "Kreatywne", "Wszystkie"];
export const CV_TEMPLATE_FILTERS = ["Ze zdjęciem", "Bez zdjęcia", "Jedna kolumna", "Dwie kolumny"];

// Statusy aplikacji (CV-D07)
export const CV_APP_STATUSES = ["Nowy", "Do wysłania", "Wysłano", "Odpowiedź", "Rozmowa", "Odrzucono / Zakończono"];

// FAQ landingu (uczciwe, bez gwarancji zatrudnienia)
export const CV_FAQ = [
  { q: "Czy muszę mieć gotowe CV?", a: "Nie. Możesz zacząć od zera — poprowadzimy Cię pytanie po pytaniu." },
  { q: "Czy muszę zakładać konto, żeby zacząć?", a: "Nie. Konto jest potrzebne dopiero przy trwałym zapisie, pobraniu dokumentu lub płatnej operacji." },
  { q: "Czy dopisujecie doświadczenie za mnie?", a: "Nie. Do CV trafiają wyłącznie informacje, które sam(a) potwierdzisz." },
  { q: "Czy gwarantujecie zatrudnienie?", a: "Nie. Przygotowujemy dokumenty i pomagamy znaleźć dopasowanych pracodawców oraz aplikować." },
];

export const CV_COST_LABEL = "Koszt zostanie podany przed uruchomieniem";
